import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import Jumbotron from 'reactstrap/lib/Jumbotron'; // Imports like this reduces build size
import classNames from 'classnames';
import { backgroundImage } from '../../modules/media/utilities';

class JumbotronVideoBlock extends Component {
  state = {
    playing: this.props.properties.autoplay,
    volume: false,
    isBuffering: true,
  };

  player = null;

  onClickFullscreen = () => {
    document.getElementsByClassName('embed-responsive-item')[0].requestFullscreen();
  }

  onPlay = () => {
    if (this.state.playing) {
        return this.setState({
        playing: false,
      });
    }
    return this.setState({
      playing: true
    });
  }

  // Handle buffering that happens when the player switches to the next video in the playerlist
  onBuffer = () => {
    if (!this.state.isBuffering) {
      this.setState({
        isBuffering: true
      });
    }
  }

  // Hide the overlay only when the player has been playing for half a second to 'hide' YouTube details.
  onProgress = (played) => {
    const { isBuffering, playing } = this.state;
    if (isBuffering && played.playedSeconds > 0.45 && playing) {
      this.setState({
        isBuffering: false
      });
    }
  }

  render() {
    const { media, properties } = this.props;
    const { playing, volume, isBuffering } = this.state;
    const mediaType = media ? media.content_type.split('/')[0] : '';
    const propStyles = [];
    Object.keys(properties.styles || {}).map(key => propStyles.push(properties.styles[key]));

    const className = classNames(
      propStyles.join(' '),
      properties.template,
      properties.extra_classes,
      {
        'jumbotron-sm': properties.styles[0] === undefined,
        'has-img': media,
        'jumbotron-video': mediaType === 'video',
      }
    );

    const jumbotronProps = {
      id: properties.id,
      className,
    };

    let image = null;
    if (mediaType === 'image') {
      image = media || null;
    }

    const jumbotronStyle = {};
    if (image && image.reference) {
      jumbotronStyle.backgroundImage = `${backgroundImage(image.reference, 'full_size')}`;
    }

    if (properties.orientation) {
      jumbotronStyle.backgroundPosition = properties.orientation;
    }

    return (
      <div>
        <Jumbotron {...jumbotronProps} style={{ position: 'relative' }}>
          <div
            className={this.props.classNames}
            id={`${properties.id ? properties.id : ''}`}
            style={this.props.jumbotronStyling}
          >
            <div className={`jumbotron-caption ${playing ? 'caption-fade' : 'caption-show'}`} dangerouslySetInnerHTML={{ __html: this.props.value }} />
          </div>
          <div className="embed-responsive embed-responsive-16by9">
            {media.thumb && (
              <div
                className={`video-thumb in ${isBuffering && 'visible'}`}
                style={{ backgroundImage: `${backgroundImage(media.thumb.reference, 'lg_43')}` }}
              />
            )}
            <ReactPlayer
              ref={(player) => { this.player = player; }}
              playing={this.state.playing}
              volume={volume ? 0.5 : 0}
              muted
              url={media.original}
              width="100%"
              height="auto"
              onBuffer={this.onBuffer}
              onProgress={this.onProgress}
              progressInterval={500}
              youtubeConfig={{ playerVars: { autoplay: this.props.properties.autoplay ? 1 : 0, loop: 1, playlist: media.reference, controls: 0 } }}
              className="embed-responsive-item"
            />
          </div>
          {!playing && !this.props.properties.autoplay && (
            <div className="big-positioned">
              <span
                className="play-button"
                onClick={this.onPlay}
              >
                <div>
                  <i className="material-icons">play_arrow</i>
                </div>
              </span>
            </div>
          )}
          <div className="video-controls">
            <div>
              {playing && (
                <span
                  className="pause-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onPlay();
                  }}
                >
                  <i className="material-icons">&#xE034;</i>
                </span>
              )}
              {!playing && this.props.properties.autoplay && (
                <span
                  className="play-button"
                  onClick={this.onPlay}
                >
                  <i className="material-icons">play_arrow</i>
                </span>
              )}
              {volume ? (
                <span
                  className="mute-button"
                  onClick={() => this.setState({ volume: false })}
                >
                  <i className="material-icons">&#xE050;</i>
                </span>
              ) : (
                <span
                  className="unmute-button"
                  onClick={() => this.setState({ volume: true })}
                >
                  <i className="material-icons">&#xE04F;</i>
                </span>
              )}
              <span
                className="fullscreen-button"
                onClick={this.onClickFullscreen}
              >
                <i className="material-icons">&#xE89F;</i>
              </span>
            </div>
          </div>
        </Jumbotron>
      </div>
    );
  }
}

JumbotronVideoBlock.propTypes = {
  block: PropTypes.object.isRequired,
  media: PropTypes.object,
  properties: PropTypes.object,
  value: PropTypes.string,
};

export default JumbotronVideoBlock;
